const workspaceFolderFallbackIconUrl = new URL(
  "../assets/workspace-folder-fallback.png",
  import.meta.url
).href;

export default workspaceFolderFallbackIconUrl;
